import React, { MouseEvent, MouseEventHandler } from 'react'

import { iconLastSearch as IconLastSearch } from 'client/icons/LocationTypes'
import IconClose from 'client/icons/Close'
import { UserSearch } from 'src/context/search/utils'

import styles from './styles.module.css'

interface IUserSearchProps {
  readonly search: UserSearch
  readonly onClick: MouseEventHandler<HTMLButtonElement>
  readonly onRemove?: MouseEventHandler<HTMLDivElement>
}

export function UserSearchItem(props: IUserSearchProps) {
  const { search, onClick, onRemove } = props

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onClick(e)
  }

  const handleRemove = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    if (onRemove) {
      onRemove(e)
    }
  }

  return (
    <li className={styles.userSearchBase} data-testid="last-user-search">
      <button className={styles.topDestinationBtn} type="button" onClick={handleClick}>
        <span className={styles.iconContainer}>
          <IconLastSearch size={20} />
        </span>
        <div>
          <span className={styles.searchText}>{search.location.text}</span>
          <p>{search.location.description}</p>
        </div>

        <span className={styles.removeContainer}>
          {onRemove && (
            <div data-testid="close-btn" aria-hidden onClick={handleRemove}>
              <IconClose />
            </div>
          )}
        </span>
      </button>
    </li>
  )
}
